export * from './box-dock-player/box-dock-player.component';
export * from './full-player/full-player.component';
export * from './player/player.component';
export * from './player-info-dialog/player-info-dialog.component';
export * from './player-queue/player-queue.component';
export * from './preview-player/preview-player.component';
export * from './web-dock-player/web-dock-player.component';
export * from './web-list-player/web-list-player.component';
export * from './web-player/web-player.component';
